import { Component, OnInit } from '@angular/core';
import {trigger, state, transition, style, animate} from '@angular/animations';
import { ChurchApplication, Pastor, Organizer } from 'src/app/Models/applications.interface';
import { AngularFireDatabase } from '@angular/fire/database';
import _ from 'lodash';
import { UserManager } from 'src/app/Services/UserManager/user-manager';
import { Profile } from 'src/app/Models/profile.interface';


@Component({
  selector: 'app-new-church-application',
  templateUrl: './new-church-application.component.html',
  styleUrls: ['../../pages/contact-us/contact-us.component.css', './new-church-application.component.css' ],
  animations: [
    trigger('trigger', [
        state('void', style({  opacity: 0 })),
        state('show', style({  opacity: 1 })),
        transition('void => *',[ animate('400ms ease-in-out')]),
        transition('* => void',[ animate('400ms ease-in-out')]),
  ])]
})
export class NewChurchApplicationComponent implements OnInit {
  currentState = 'void'
  app = {} as  ChurchApplication
  errorMessage = ''
  verificationMessage: boolean = false;
  profile: Profile;
  submitting = false
  constructor(
    private db: AngularFireDatabase,
    public um: UserManager
    ) {
      setTimeout(() => {
        this.um.getProfileSubject()
        .subscribe(profile => {
          if(!profile || !!profile && profile.anonymous){
            this.um.openSignUp()
          } else {
            profile = profile as Profile
    
            this.profile = profile;
            this.app.pastor = {} as Pastor;
            this.app.entityId = '';
            this.app.pastor.name = ''
            this.app.pastor.email = ''
            // this.app.pastor.uid = profile.uid;  // not going to set this here.  We dont know
            this.app.organizer = {} as Organizer;
            this.app.organizer.name = profile.firstname + ' ' + profile.lastname
            this.app.organizer.email = profile.email
            this.app.organizer.uid = profile.uid
            this.app.city = profile.city;
            this.app.country = profile.country;
            this.um.hideLoginContainer();
          }
        })
        
      },1000)

     }

  ngOnInit(): void {
    this.currentState = 'show'
  }


removeSpaces = () => {
  this.app.entityId = _.lowerCase(_.replace(this.app.entityId, /[^0-9a-z]/gi, ''))// / /g, '')
}
  validate = async  () => {
      
      
      this.removeSpaces()
      if(!this.app.name){ return Promise.reject('Organization Name Required')}
      if(!this.app.entityId || this.app.entityId === ''){ return Promise.reject('Code Required')}
      const available = await this.um.checkIfEntityAvailable(this.app.entityId)
      if(!available) {
        return Promise.reject('Organization Shortname is not available')
      }
      if(!this.app.phone){ return Promise.reject('Organization Phone Required') } 
      if(!this.app.email){ return Promise.reject('Email Required') }
      if(!this.app.address){ return Promise.reject('Address Required')}
      if(!this.app.city){ return Promise.reject('City Required')}
      if(!this.app.country){ return Promise.reject('Country Required')}
      if(!this.app.pastor.name){ return Promise.reject("Pastor's Name Required")}
      if(!this.app.pastor.phone && !this.app.pastor.email){ return Promise.reject("Pastor's Phone Required") } 
      if(!this.app.pastor.email && !this.app.pastor.phone){ return Promise.reject('Email Required') } 

      return 
    
    

  }

  submitApplication = async () => {
    if(this.submitting) { return }
    
    this.submitting = true
    try{
      await this.validate()
    } catch(e) {
      this.displayErrorMessage(e)
      this.submitting = false
      return
    }
    this.app.date = _.now()
    await this.db.list('ChurchApplications').push(this.app)
    
    this.app = {} as ChurchApplication
    this.displaySuccessMessage()
    setTimeout(() => this.submitting = false, 3000)
  }

  displaySuccessMessage(){
    this.verificationMessage = true
  }
  hideSuccessMessage(){
    this.verificationMessage = false
  }

  displayErrorMessage(message: string){
    this.errorMessage = message
    setTimeout(() => this.hideErrorMessage(), 3000)
  }

  hideErrorMessage(){
    this.errorMessage = null
  }
}
